import { Box, NumberInput, NumberInputField } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useState } from 'react';

import { Condition } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const InputPercentage = ({
  label,
  isRequired,
  placeholder,
  value,
  onChange,
  margin,
  className,
  error,
  height,
  rightLabel,
  rightLabelPosition = 'space-between',
}) => {
  const isError = !isEmpty(error);
  const [internalValue, setInternalValue] = useState(value);

  const handleChange = (valueAsString, valueAsNumber) => {
    setInternalValue(valueAsString);
    const value = isNaN(valueAsNumber) ? 0 : valueAsNumber;
    onChange(value);
  };

  return (
    <Box margin={margin} className={`${className} ${styles['input-percentage-container']}`}>
      <Condition statement={label}>
        <Box className={styles['label__container']} justifyContent={rightLabelPosition}>
          <TextSemiBold className={styles['text__title']}>
            {label}{' '}
            <Condition statement={isRequired}>
              <span>*</span>
            </Condition>
          </TextSemiBold>
          <Condition statement={rightLabel}>
            <Box className={styles['box__right-label']}>{rightLabel}</Box>
          </Condition>
        </Box>
      </Condition>
      <Box position="relative">
        <NumberInput value={internalValue || ''} onChange={handleChange} min={0} max={100} precision={2}>
          <NumberInputField
            placeholder={placeholder}
            className={styles['input-percentage__box-input']}
            height={height}
            background={internalValue ? 'white' : 'var(--color-semantic-background)'}
          />
        </NumberInput>
        <Box className={styles['input-percentage-overlay']}>%</Box>
      </Box>

      <Condition statement={isError}>
        <TextRegular className={styles['error__text']}>{error?.message}</TextRegular>
      </Condition>
    </Box>
  );
};

export default InputPercentage;
